( function( global, $ ) {
    "use strict";

    var _events = {
        onKeydownTitle: function(ev) {
            var $input = $(this);

            if (typeof($input.data('originalValue')) === 'undefined') {
                $input.data('originalValue', $input.val());
            }
        },

        onChangeTitle: function(ev) {
            var $input = $(this),
                titleField = $input.data('edit-title-field') || 'title',
                value = $input.val();

            function _resetValue() {
                $input.val($input.data('originalValue'));
            }

            if (value === '') {
                _resetValue();

                return;
            }

            $input.attr('name', 'resource['+titleField+']');

            var data = $input.serializeArray();

            $input.removeAttr('name')
                .addClass('ajax-loading');

            $.App.api('PATCH', $input.data('edit-title'), data)
                .done(function(response) {
                    if (! response.success) {
                        _resetValue();
                    }
                })
                .fail(function() {
                    _resetValue();
                })
                .always(function() {
                    $input.removeClass('ajax-loading');
                })
            ;
        }
    };

    var $body = $('body');

    $body.on('app.init', function(ev) {
        var $container = $(ev.container);

        $container.find('[data-edit-title]')
            .on('keydown.edit-title', _events.onKeydownTitle)
            .on('change.edit-title', _events.onChangeTitle);
    });

}( window.groots, jQuery ));
